import { ActionTypes } from './types';

export function setSites(companyId: string, sites: Site[]) {
  return {
    type: ActionTypes.SET_SITES,
    companyId,
    sites
  }
}